import { GamePanel } from "../components/Game/Panel.tsx";

export default GamePanel;